import { render, staticRenderFns } from "./openBook.vue?vue&type=template&id=e7d31c68&scoped=true&"
import script from "./openBook.vue?vue&type=script&lang=js&"
export * from "./openBook.vue?vue&type=script&lang=js&"
import style0 from "./openBook.vue?vue&type=style&index=0&id=e7d31c68&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7d31c68",
  null
  
)

export default component.exports